import React from "react";
import MetaTags from "react-meta-tags";
import Subscribe from "../../component/Subscribe";
import "../SCSS/Styles.css";

function NewsletterTwentyNine() {
  return (
    <>
      <section
        className="about-banner-section"
        style={{ padding: "150px 0 62px" }}
      >
        <div className="about-circle">
          <div className="about-circle-1"></div>
          <div className="about-circle-2"></div>
          <div className="about-circle-3"></div>
          <div className="about-circle-4"></div>
          <div className="about-circle-5"></div>
        </div>
        <div className="about-banner-container">
          <div className="about-content">
            <h1 className="about-title" style={{ paddingTop: "25px" }}>
              SustainabilityConnect
            </h1>
            <p
              className="about-description"
              style={{ fontSize: "25px", marginTop: "18px", marginBottom: "0" }}
            >
              Newsletter February 2025
            </p>
          </div>
        </div>
        <div className="about-elements">
          <div className="about-element-1"></div>
          <div className="about-element-2"></div>
          <div className="about-element-3"></div>
          <div className="about-element-4"></div>
          <div className="about-element-5"></div>
        </div>
      </section>
      <div className="newsletter-twenty-seven-container">
        <MetaTags>
          <title>
            EBA Issues Comprehensive Guidelines for ESG Risk Management in
            Banking.
          </title>
          <meta
            name="description"
            content="The European Banking Authority (EBA) has released definitive guidelines mandating that financial institutions integrate Environmental, Social, and Governance (ESG) considerations into their risk management frameworks. "
          />
          <meta
            property="og:title"
            content="UpdaptCSR | Sustainability Platform"
          />
        </MetaTags>{" "}
        <div
          className="Newsletter-title1"
          style={{ paddingTop: "56px", fontSize: "32px" }}
        >
          EBA Issues Comprehensive Guidelines for ESG Risk Management in
          Banking.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/images/eba_feb_2025.webp")}
            alt="EBA Issues Comprehensive Guidelines for ESG Risk Management in Banking"
          />
        </figure>
        <p>
          The European Banking Authority (EBA) has released definitive
          guidelines mandating that financial institutions integrate
          Environmental, Social, and Governance (ESG) considerations into their
          risk management frameworks. These directives require banks to conduct
          regular materiality assessments of ESG risks, utilizing tools and
          methodologies to evaluate their potential impacts across short,
          medium, and long-term horizons. Additionally, institutions must
          establish information management systems to effectively identify,
          collect, and analyze ESG-related data.
        </p>
        <p>
          These requirements will become effective for large institutions in
          January 2026, with small and non-complex institutions granted an
          additional year to comply. The EBA's initiative underscores the
          escalating importance of ESG factors in maintaining the stability and
          soundness of financial institutions, particularly as the European
          Union advances toward its goal of climate neutrality by 2050.
        </p>
        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            To align with the EBA's new ESG risk management guidelines, banks
            must integrate ESG factors into their risk frameworks, conduct
            regular materiality assessments, and implement robust data
            collection systems. They should develop forward-looking risk models,
            scenario analyses, and strategic action plans, ensuring compliance
            by 2026. Strengthening governance structures and enhancing ESG
            disclosures will be crucial for long-term resilience.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          EU Unveils Competitiveness Compass to Streamline Sustainability
          Reporting.
        </div>
        <div className="Newsletter-picture">
          <figure style={{ marginTop: "25px" }}>
            <img
              className="picture"
              src={require("../../../../../assets/images/eu_feb_2025.webp")}
              alt="EU Unveils Competitiveness Compass to Streamline Sustainability Reporting."
            />
          </figure>
        </div>
        <p>
          The European Commission has introduced the ‘Competitiveness Compass,’
          a strategic roadmap designed to enhance Europe's productivity and
          global standing. A key component of this initiative is the forthcoming
          "Omnibus" package, scheduled for proposal in February 2025, which aims
          to simplify sustainable finance reporting, due diligence, and taxonomy
          regulations. This effort targets the Corporate Sustainability
          Reporting Directive (CSRD), Corporate Sustainability Due Diligence
          Directive (CSDDD), and the Taxonomy Regulation.
        </p>
        <p>
          A significant focus of the Omnibus package is to alleviate reporting
          burdens for businesses, particularly small and medium-sized
          enterprises (SMEs). The Commission plans to reduce reporting
          requirements by at least 25% for all companies and 35% for SMEs. This
          includes proposing a new category for small mid-cap companies, which
          will be subject to less complex sustainability reporting and due
          diligence obligations. Additionally, measures will be implemented to
          prevent smaller companies in supply chains from facing excessive
          reporting demands not intended by legislators.
        </p>
        <p>
          By optimizing sustainability reporting frameworks, the EU is
          reinforcing its commitment to both economic growth and environmental
          responsibility. The reforms will enable businesses to focus on
          innovation and competitiveness, while maintaining strong
          sustainability standards. These measures demonstrate the EU’s
          leadership in aligning corporate sustainability with economic
          resilience, creating a streamlined and future-ready regulatory
          environment.
        </p>
        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            To align with the EU’s streamlined sustainability reporting updates,
            companies should enhance data management systems, integrate ESG
            metrics into core strategies, and adopt digital reporting solutions
            for efficiency. Businesses should also simplify supply chain due
            diligence, train teams on new compliance requirements, and leverage
            sustainability reporting software to stay agile. Proactive
            adaptation will ensure competitiveness and compliance in the
            evolving regulatory landscape.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          Switzerland Advances Climate Strategy with Aggressive Carbon Reduction
          Plan.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/images/switz_feb_2025.webp")}
            alt="Switzerland Advances Climate Strategy with Aggressive Carbon Reduction Plan."
          />
        </figure>
        <p>
          In a significant policy advancement, Switzerland has set a target to
          reduce its greenhouse gas emissions by at least 65% by 2035, compared
          to 1990 levels. This objective aligns with the nation's Climate and
          Innovation Act, which was endorsed through a 2023 referendum. The Act
          not only enshrines the 2050 net-zero goal into law but also
          establishes interim national and sector-specific targets to facilitate
          this transition.
        </p>
        <p>
          To achieve these ambitious goals, Switzerland plans to implement a
          comprehensive strategy emphasizing domestic measures. Key initiatives
          include reducing energy consumption and incentivizing the shift from
          fossil fuel-based power in industries, buildings, and homes. While the
          primary focus is on internal actions, the country retains the option
          to incorporate international mitigation outcomes to meet its targets,
          though this is anticipated to be minimal.
        </p>
        <p>
          This commitment reflects Switzerland's dedication to the Paris
          Agreement's objectives and the Intergovernmental Panel on Climate
          Change's recommendations to limit global warming to 1.5 degrees
          Celsius. By setting these stringent targets, Switzerland aims to lead
          by example in global climate action, demonstrating that ambitious
          environmental policies are achievable through comprehensive
          legislative frameworks and public support.
        </p>
        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            Businesses stand to gain significantly from Switzerland’s ambitious
            emission reduction targets, as sustainability-driven policies foster
            innovation, efficiency, and resilience. Companies investing in green
            technologies and carbon reduction strategies can access new market
            opportunities, regulatory incentives, and investor confidence. A
            low-carbon transition enhances brand reputation, mitigates climate
            risks, and ensures long-term competitiveness in an evolving global
            economy.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          Australia's $1.24 Billion Initiative to Decarbonize Aluminium
          Production.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/images/aus_feb_2025.webp")}
            alt="Australia's $1.24 Billion Initiative to Decarbonize Aluminium Production."
          />
        </figure>
        <p>
          The Australian government has announced a substantial investment of
          $1.24 billion to decarbonize its aluminium industry. This initiative
          introduces a Green Aluminium Production Credit, designed to
          incentivize smelters to transition to renewable energy sources by
          2036. Eligible facilities will receive financial support for each
          tonne of clean aluminium produced over a decade, promoting the
          adoption of sustainable practices within the sector.
        </p>
        <p>
          Aluminium production is notably energy-intensive, with approximately
          70% of its emissions stemming from electricity consumption during the
          smelting process. Traditionally, a significant portion of this energy
          has been derived from fossil fuels. By encouraging the shift to
          renewable energy, this initiative aims to significantly reduce the
          industry's carbon footprint.
        </p>
        <p>
          This investment aligns with Australia's broader strategy to achieve
          net-zero emissions and positions the nation as a leader in sustainable
          industrial practices. As global demand for environmentally friendly
          materials rises, Australia's commitment to producing low-carbon
          aluminium not only addresses climate change but also enhances the
          country's competitiveness in the evolving green economy.
        </p>
        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            Australia’s green aluminium initiative is set to revolutionize
            industrial sustainability by driving decarbonization and enhancing
            global competitiveness. By incentivizing smelters to transition to
            renewable energy, industries such as automotive, aerospace, and
            construction gain access to sustainable materials, aligning with ESG
            mandates. This strategic shift strengthens supply chains, fosters
            technological advancements, and positions the country as a leader in
            low-carbon industrial innovation.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          The United States Clean Fuel Tax Credit Reshapes Corporate
          Sustainability Strategies.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/images/fuel_feb_2025.webp")}
            alt="The United States Clean Fuel Tax Credit Reshapes Corporate Sustainability Strategies."
          />
        </figure>
        <p>
          The U.S. Department of the Treasury and the Internal Revenue Service
          have issued guidance on the Clean Fuel Production Credit (Section
          45Z), effective January 1, 2025. This credit incentivizes the domestic
          production of transportation fuels with lifecycle greenhouse gas
          emissions below specified thresholds, encompassing both sustainable
          aviation fuel (SAF) and other transportation fuels. The guidance
          includes a notice of intent to propose regulations and an annual
          emissions rate table, directing taxpayers to appropriate methodologies
          for determining the lifecycle greenhouse gas emissions of their fuels.
        </p>
        <p>
          To qualify for the credit, producers must register with the IRS as
          clean fuel producers. The credit amount is determined by the fuel's
          carbon intensity, with net-zero emission fuels eligible for up to
          $1.00 per gallon, and $1.75 per gallon for SAF. The credit phases out
          for fuels with emissions at or above 50 kilograms of CO₂ equivalent
          per million British thermal units.
        </p>
        <p>
          This initiative aims to stimulate investment in cleaner fuel
          technologies, contributing to the reduction of greenhouse gas
          emissions in the transportation sector. By providing financial
          incentives, the government seeks to encourage the adoption of
          sustainable practices among fuel producers, thereby advancing
          environmental sustainability goals.
        </p>
        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            The Clean Fuel Production Credit will drive companies to recalibrate
            their strategies toward low-carbon fuel innovation. With incentives
            tied to emissions intensity, firms will invest in sustainable
            technologies, optimize supply chains, and enhance lifecycle
            assessments. This shift will accelerate decarbonization efforts,
            positioning clean fuel producers for regulatory compliance and
            long-term competitive advantage.
          </p>
        </div>
      </div>
      <Subscribe />
    </>
  );
}

export default NewsletterTwentyNine;
